module.exports = __webpack_public_path__ + "img/gzh_qrcode.69ad5166.png";